import * as Types from './types';
import { actionTypes } from './constants';

export const setSessionDurationAction = (duration: number): Types.ISetSessionDurationAction => ({
    type: actionTypes.SET_SESSION_DURATION,
    payload: duration
});

export const setSessionEnabledAction = (enabled: boolean): Types.ISetSessionEnabledAction => ({
    type: actionTypes.SET_SESSION_ENABLED,
    payload: enabled
});

export const setSessionLimitAction = (sessionLimit: number | null): Types.ISetSessionLimitAction => ({
    type: actionTypes.SET_SESSION_LIMIT,
    payload: sessionLimit
});

export const setSessionTimeoutShownAction = (isShown: boolean): Types.ISetSessionTimeoutShownAction => ({
    type: actionTypes.SET_SESSION_TIMEOUT_SHOWN,
    payload: isShown
});
